import { useCallback, useEffect, useRef, useState } from 'react';

// "Merged “Swan K-9 Search Report” into the document above · Undo" — every
// correction says what it did and offers one click back (plan §7d.2).
const TOAST_MS = 8000;

export function useUndoToast() {
  const [toast, setToast] = useState(null);      // {id, text, canUndo}
  const timer = useRef(null);
  const clear = useCallback(() => { if (timer.current) clearTimeout(timer.current); timer.current = null; setToast(null); }, []);
  const show = useCallback((text, { canUndo = true } = {}) => {
    if (timer.current) clearTimeout(timer.current);
    setToast({ id: Date.now(), text, canUndo });
    timer.current = setTimeout(() => { timer.current = null; setToast(null); }, TOAST_MS);
  }, []);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
  return { toast, show, clear };
}

export default function UndoToast({ toast, onUndo, onClose, busy = false }) {
  if (!toast) return null;
  return (
    <div className="seg-toast" role="status" data-testid="seg-toast">
      <span className="seg-toast-text">{toast.text}</span>
      {toast.canUndo && (
        <button type="button" className="seg-toast-undo" disabled={busy} onClick={onUndo}>Undo</button>
      )}
      <button type="button" className="seg-toast-close" aria-label="Dismiss" onClick={onClose}>×</button>
    </div>
  );
}
